import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Col } from 'reactstrap'
import styled from 'styled-components'
import { Bar } from 'react-chartjs-2'
import ReactResizeDetector from 'react-resize-detector'
import { withNamespaces } from 'react-i18next'

import moment from 'moment'
import 'moment/locale/ru'
import 'moment/locale/zh-cn'
import 'moment/locale/bg'
import 'moment/locale/cs'
import 'moment/locale/id'
import 'moment/locale/ko'
import 'moment/locale/my'
import 'moment/locale/pl'
import 'moment/locale/th'
import 'moment/locale/zh-hk'
import 'moment/locale/zh-tw'
import 'moment/locale/vi'
import 'moment/locale/ja'

import { fetchChart, setFilterDate } from '../../ducks/chart'

import { PlayArrow } from 'material-react-icons'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;

  margin-bottom: 20px;
  padding: 28px 20px 28px 32px;
`

const StyledControlBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 20px;

  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #8798ad;
`

const StyledControlArrow = styled.div`
  transform: rotateY(${(props) => (props.left ? '180deg' : '0deg')});
  cursor: pointer;
  transition: opacity 0.2s;

  :hover {
    opacity: 0.8;
  }
`

const StyledControlText = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`

const StyledError = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #8798ad;

  display: flex;
  justify-content: center;
  align-items: center;

  min-height: ${(props) => props.height}px;
`

class Chart extends Component {
  constructor(props) {
    super(props)

    this.state = {
      chartWidth: 500
    }
  }

  componentDidMount() {
    this.props.fetchChart()
  }

  onResize = (chartWidth) => {
    this.setState({ chartWidth })
  }

  renderControlBar = () => {
    const { i18n } = this.props
    const { currentDate, selectedDate } = this.props.chart
    const previousMonth = moment(selectedDate).subtract(1, 'month')
    const nextMonth = moment(selectedDate).add(1, 'month')

    return (
      <StyledControlBar>
        <StyledControlArrow
          left
          onClick={() => this.props.setFilterDate(previousMonth)}
        >
          <PlayArrow />
        </StyledControlArrow>
        <StyledControlText>
          {selectedDate.locale(i18n.language).format('MMMM YYYY')}
        </StyledControlText>
        {nextMonth.isSameOrBefore(currentDate, 'month') && (
          <StyledControlArrow
            onClick={() => this.props.setFilterDate(nextMonth)}
          >
            <PlayArrow />
          </StyledControlArrow>
        )}
      </StyledControlBar>
    )
  }

  render() {
    const { t } = this.props
    const { labels, datasets, currentDate, selectedDate } = this.props.chart
    const { chartWidth } = this.state

    const isStackedBar = currentDate.isSame(selectedDate, 'month')

    const intDatasets = datasets.map((dataset) => ({
      ...dataset,
      data: [...dataset.data],
      label: t(`common:${dataset.label}`)
    }))

    return (
      <Col md={12} lg={6}>
        <Wrapper>
          {/* {loading && <Preloader />} */}
          {this.renderControlBar()}
          <ReactResizeDetector handleWidth onResize={this.onResize} />
          {labels.length === 0 && (
            <StyledError height={chartWidth}>{t('chart:noData')}</StyledError>
          )}

          {labels.length > 0 && (
            <Bar
              data={{
                labels,
                datasets: intDatasets
              }}
              width={chartWidth}
              height={chartWidth}
              options={{
                tooltips: {
                  mode: 'index',
                  intersect: false
                },
                scales: {
                  xAxes: [
                    {
                      stacked: isStackedBar,
                      gridLines: {
                        display: false
                      },
                      ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        fontSize: 11,
                        fontColor: '#8B93A7',
                        fontFamily: 'Open Sans'
                      }
                    }
                  ],
                  yAxes: [
                    {
                      ticks: {
                        beginAtZero: true
                      }
                    }
                  ]
                },
                layout: {
                  padding: {
                    left: 0
                  }
                },
                legend: {
                  display: false
                }
              }}
            />
          )}
        </Wrapper>
      </Col>
    )
  }
}

export default compose(
  connect(
    ({ chart }) => ({
      chart
    }),
    { fetchChart, setFilterDate }
  ),
  withNamespaces()
)(Chart)
